/**
 * 「航拍还在飞」接续条用到的一点工具。
 *
 * ── 这个文件为什么被砍小了（2026-09-16 实机之后）────────────────────
 *
 * 第一版做了三档：还在飞 / 已结束 / 已中断，按订单的 orderStatus 分支。
 * Zack 在真机上一验就露馅：那次航拍**正在进行**（计时器 00:19、RTK 在飞），
 * 条上却写着「上次航拍已结束」。
 *
 * 根因是我把「航拍中」等同于 OrderStatus.TICKET_TYPE_LIVE_STREAM_PUSHED ——
 * 但订单详情当时显示的是「进行中」，说明起飞初期的状态并不是它。**那套状态
 * 映射是我猜的，没有实据。**
 *
 * 所以整块拿掉，只留一件事：还在飞的时候，把接回去这一下做顺。
 * 而「还在飞」的判据换回 findliveStreamPushedByTicketId ——
 * 原来的硬跳就是靠它，它是被生产验证过的。
 *
 * 教训记在这里：**没有实据的状态映射不要写进分支**。宁可少说一句，
 * 也不要说错 —— 用户看到「已结束」而无人机还在天上，是在骗他。
 */

/** 起飞时 aerial 页写在 localStorage 里的那条记录 */
export interface AerialTimerRecord {
  timestamp: number
  ticketId: string
}

/**
 * 本地那条记录还算不算数（结构完整 + 没老到离谱）。
 *
 * 只拿它算「已飞了多久」，**不拿它判断在不在飞** —— 判断在不在飞是
 * findliveStreamPushedByTicketId 的事。
 */
export const isUsableRecord = (
  record: AerialTimerRecord | null | undefined,
  now = Date.now(),
): record is AerialTimerRecord => {
  if (!record || typeof record !== 'object') return false
  if (!record.ticketId || typeof record.ticketId !== 'string') return false
  if (!Number.isFinite(record.timestamp)) return false
  const elapsed = now - record.timestamp
  // 负数 = 时钟跳变；超过一天的一律当过期
  return elapsed >= 0 && elapsed < 24 * 60 * 60 * 1000
}

/** mm:ss。给接续条显示「已飞 02:14」用 */
export const formatElapsed = (ms: number) => {
  const total = Math.max(0, Math.floor(ms / 1000))
  const m = Math.floor(total / 60)
  const s = total % 60
  return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`
}
